export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7347.0902fc83.jpg";